import React , { useState }  from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion , AnimatePresence} from 'framer-motion';
import '../Styles/ProjectsSection.css';

const projects = [
      {
        title: "Malloy Ecosystem (Open-Source Contributor)",
        type: "Open Source",
        location: "Remote",
        period: "2024 – Present",
        description: [
            "Delivered 29 merged pull requests in the Malloy ecosystem, spanning the Publisher and VS Code Extension projects, contributing to core platform capabilities.",
            "Implemented Snowflake RSA authentication and DuckDB cloud storage integrations for GCS and S3, expanding the platform's multi-database connectivity.",
            "Built multi-database connection enhancements in TypeScript, enabling seamless interaction across diverse data sources within the Malloy toolchain."
        ],
        technologies: ["TypeScript", "Snowflake", "DuckDB", "GCS", "S3", "VS Code Extension", "Git"],
        githubLink: "https://github.com/malloydata"
    },
      {
        title: "Mock Market",
        type: "Web Application",
        location: "Boulder, CO",
        period: "November 2024 – December 2024",
        description: [
            "Engineered a real-time stock trading simulator using MERN stack that integrates with financial APIs to provide live market data, enabling users to practice trading strategies with virtual currency.",
            "Implemented secure user authentication, real-time portfolio tracking, and automated price alerts, creating an intuitive interface for users to manage investments and monitor market performance.",
            "Containerized and deployed the application using Docker, Kubernetes, and Google Cloud Platform, ensuring scalability and maintainable infrastructure through CI/CD pipelines."
        ],
        technologies: ["MongoDB", "Express.js", "React.js", "Node.js", "HTML", "CSS", "GitHub", "Postman", "REST APIs", "Netlify", "Docker", "GCP", "Kubernetes", "CI/CD"],
        githubLink: "https://github.com/manojdeep14/Mock_market",
        websiteLink: "https://mock-market-chi.vercel.app"
    },
    {
        title: "Recipe Realm",
        type: "Web Application",
        location: "Boulder, CO",
        period: "April 2024 – May 2024",
        description: [
            "Recipe Realm is a MERN stack web application I developed to manage recipes. With user authentication and full CRUD operations, users can effortlessly manage and share their culinary creations.",
            "The application features interactive elements such as likes, comments, save posts and an intuitive search functionality, fostering a vibrant community of food enthusiasts.",
            "Deployed on GCP and Netlify, Recipe Realm is accessible and scalable, offering a seamless user experience across devices."
        ],
        technologies: ["MongoDB", "Express.js", "React.js", "Node.js", "HTML", "CSS", "GitHub", "Postman", "REST APIs", "Netlify", "Docker", "GCP", "Third-party APIs"],
        githubLink: "https://github.com/manojdeep14/Recipe-Realm",
        websiteLink: "https://recipe-realm-fsp.netlify.app"
    },
    {
      title: "Document Manager",
      type: "Web Application",
      location: "Herndon, VA",
      period: "June 2024 – August 2024",
      description: [
        "As part of my internship, I also developed a Document Service Application that facilitated efficient document management and storage. Utilizing Spring Boot, PostgreSQL, and React, I created a secure and scalable solution.",
        "The application automated document handling processes, incorporating features like version control, search, and retrieval, which improved accessibility and workflow.",
        "With a focus on backend robustness and frontend usability, I employed JUnit testing, Mockito, and LocalStack to deliver a high-quality, reliable service for document management."
        ],
        technologies: ["Spring Boot", "PostgreSQL", "React", "REST API", "Amazon S3", "LocalStack", "Junit", "Docker", "Mockito", "Git"],
  },
  {
    title: "Task Manager",
    type: "Web Application",
    location: "Herndon, VA",
    period: "June 2024 – August 2024",
    description: [
      "During my internship at Karsun Solutions, I developed a comprehensive Task Manager application using Spring Boot, React, and PostgreSQL. This tool was designed to streamline task assignment, tracking, and completion.",
      "The application featured a user-friendly interface and robust backend, incorporating JUnit testing, Mockito, and LocalStack to ensure reliable performance and seamless user interactions.",
      "By leveraging REST APIs and integrating advanced functionalities, the Task Manager application significantly enhanced team productivity and operational efficiency."
      ],
    technologies: ["Spring Boot", "PostgreSQL", "React", "REST API", "Junit", "Docker", "Mockito", "Git"],
    githubLink: "https://github.com/Manojdeep-Dakavaram/Task-Manager",
},
    {
        title: "Automated Dermoscopic Analysis",
        type: "Research Project",
        location: "Boulder, CO",
        period: "April 2024 – May 2024",
        description: [
            "This project harnessed the power of deep learning to create an automated system for skin lesion segmentation and disease classification. With models like U-NET, VGG-16, and ResNet50, I achieved a 75% accuracy rate in classifying seven types of skin cancer.",
            "The system utilized advanced image processing techniques, ensuring precise segmentation with a 0.51 Jaccard index threshold.",
            "By leveraging Python, TensorFlow, and other machine learning tools, this project showcases the potential of AI in healthcare for early disease detection."
        ],
        technologies: ["Python", "U-NET", "ResNet50", "VGG16", "Keras", "Tensorflow", "Pandas", "Scikit-learn", "Kaggle Notebooks", "Git", "CV2"],
        githubLink: "https://github.com/manojdeep14/Lesion-Segmentation-and-Disease-Classification"
    },
    {
        title: "AI-Generated Text Detection",
        type: "NLP Project",
        location: "Boulder, CO",
        period: "Nov 2023 – Dec 2023",
        description: [
            "I built a sophisticated classifier to detect AI-generated text, achieving an 85% accuracy rate. Using models such as BERT, DistilBERT, and GPT-2, I explored the intersection of AI and linguistics.",
            "This project highlights the growing need to discern authenticity in the age of machine-generated content.",
            "By integrating PyTorch, Pandas, and Scikit-learn, I enhanced the model’s performance, making it a reliable tool for text classification."
        ],
        technologies: ["BERT", "DistilBERT", "GPT-2", "PyTorch", "Pandas", "Scikit-learn", "Kaggle Notebooks", "Git"],
        githubLink: "https://github.com/manojdeep14/AI-Text-Detection"
    },
    {
        title: "Feed the Hunger",
        type: "Android Application",
        location: "Coimbatore, India",
        period: "July 2020 – Jan 2021",
        description: [
            "Feed the Hunger is an Android application designed to reduce food waste by connecting surplus food sources with NGOs and shelters. Developed using Java, Android Studio, and Firebase, it promotes sustainability and community support.",
            "The app features user-friendly navigation and real-time updates, ensuring efficient food distribution to those in need.",
            "By leveraging Google Maps API, the app facilitates easy location tracking and coordination, making it a valuable tool for social good."
        ],
        technologies: ["Java", "Android Studio", "Material Design", "Firebase", "Google Maps API", "Git", "UI/UX Design"],
        githubLink: "https://github.com/crazyotakuu/FeedTheHunger"  
    },
    {
        title: "Leave Manager",
        type: "Web Application",
        location: "Coimbatore, India",
        period: "June 2020 – November 2020",
        description: [
            "Leave Manager is a web application I developed to simplify staff leave management. Built with HTML, CSS, JavaScript and PostgreSQL, it offers a user-friendly interface for efficient leave request tracking and processing.",
            "The application streamlines the administrative process, making it easier for organizations to manage staff leave effectively",
            "With features like leave balance tracking and approval workflows, Leave Manager enhances organizational workflow and productivity.",
        ],
        technologies: ["HTML", "CSS", "JavaScript", "Bootstrap", "Java Servlets", "JSP", "PostgreSQL", "Git", "UI/UX Design"]
    }
];

const ProjectCard = ({ project }) => {
  return (
    <motion.div 
      className="project-card"
      whileHover={{ y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <div className="project-content">
        <h3 className="project-title">{project.title}</h3>
        <p className="project-meta">{project.type} | {project.location}</p>
        <p className="project-period">{project.period}</p>
        <ul className="project-description">
          {project.description.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
        <div className="project-tech">
          {project.technologies.map((tech, i) => (
            <span key={i} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="project-links">
          {project.githubLink && (
            <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="project-link github">
              GitHub
            </a>
          )}
          {project.websiteLink && (
            <a href={project.websiteLink} target="_blank" rel="noopener noreferrer" className="project-link website">
              Website
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
};
  
  function ProjectsSection() {
    const [filter, setFilter] = useState('All');
    const categories = ['All', 'Open Source', 'Web Application', 'Research Project', 'NLP Project', 'Android Application'];
  
    const filteredProjects = filter === 'All' 
      ? projects 
      : projects.filter(project => project.type === filter);
  
    return (
      <section id="projects" className="projects-section">
        <Container>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Projects & Outside Experience
          </motion.h2>
          
          <div className="filter-buttons">
            {categories.map(category => (
              <button 
                key={category}
                className={`filter-btn ${filter === category ? 'active' : ''}`}
                onClick={() => setFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
  
          <AnimatePresence>
          <Row>
            {filteredProjects.map((project, index) => (
              <Col lg={4} md={6} key={project.title}>
                <ProjectCard project={project} />
              </Col>
            ))}
          </Row>
        </AnimatePresence>
        </Container>
      </section>
    );
  }
  
  export default ProjectsSection;